import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./laserVia.png"

const レーザービア径 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { laserVia: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend="レーザービア径／ランド径"
      helpURL={HELP_LINKS["レーザービア径／ランド径"]}
      src={img}
    >
      <RadioGroup
        name={FIELD_NAMES["レーザービア径／ランド径"]}
        selectedValue={values.laserVia}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["レーザービア径／ランド径"]["φ0.1/0.3mm"].value}>φ0.1/0.3mm</Radio>
          <Radio value={ESTIMATE_CONSTANT["レーザービア径／ランド径"]["φ0.1/0.275mm"].value}>φ0.1/0.275mm</Radio>
          <Radio value={ESTIMATE_CONSTANT["レーザービア径／ランド径"]["φ0.1/0.25mm"].value}>φ0.1/0.25mm</Radio>
          <Radio value={ESTIMATE_CONSTANT["レーザービア径／ランド径"]["φ0.08/0.23mm"].value}>φ0.08/0.23mm</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.laserVia} />
    </OneClickField>
  )
}

export default レーザービア径
